<template>
  <div>
    <div :class="`${numberItemsHasNoWarehouseLocations < 0 ? 'error' : ''}`">total quantity <b>{{ item.quantity }}</b> / number of items have no warehouse locations <b>{{ numberItemsHasNoWarehouseLocations }}</b></div>
    <br/>
    <div class="locations-list">
      <WarehouseMapLocation v-for="(location, key) in item.warehouseLocations"
        :key="key"
        :warehouseMapLocation="location"
        :item="item"
        @showPopupDelete="handlerShowPopupDelete"
      />
    </div>

    <v-row class="mb-2">
      <v-col cols="12">
        <v-btn
          color='transparent'
          depressed
          @click="addWarehouseLocation"
          class='px-2'
        >
          <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
          <span class="text-subtitle-2 font-weight-bold">Add Location</span>
        </v-btn>
      </v-col>
    </v-row>

    <WarehouseMapLocationPopupDelete
      :showPopup='showPopupDelete'
      @cancel='handleDeleteCancel'
      @delete='handleDeleteOK'
    />
  </div>
</template>

<script>
import WarehouseMapLocation from '@/components/warehouses/warehouseMapLocation'
import WarehouseMapLocationPopupDelete from '@/components/warehouses/popups/deleteWarehouseMapLocation'
export default {
  name: 'WarehouseMapItemAssign',
  components: {
    WarehouseMapLocation,
    WarehouseMapLocationPopupDelete
  },
  props: {
    warehouseMap: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    showPopupDelete: false,
    warehouseMapLocationForDelete: null
  }),
  computed: {
    numberItemsHasNoWarehouseLocations() {
      if (this.item?.warehouseLocations?.length) {
        const numberItemsHaveLocation = this.item.warehouseLocations.reduce((a, l) => a + parseInt(l.value), 0)
        return this.item.quantity - numberItemsHaveLocation
      }
      return this.item?.quantity || 0
    }
  },
  methods: {
    handlerShowPopupDelete(warehouseMapLocationForDelete) {
      this.warehouseMapLocationForDelete = warehouseMapLocationForDelete
      if (this.warehouseMapLocationForDelete) {
        this.showPopupDelete = true
      }
    },
    handleDeleteCancel() {
      this.showPopupDelete = false
      this.warehouseMapLocationForDelete = null
    },
    handleDeleteOK() {
      const locationForDelete = this.warehouseMapLocationForDelete
      if (!locationForDelete) {
        return
      }

      this.item.warehouseLocations = this.item.warehouseLocations.filter(location => {
        return !(location.rack.id === locationForDelete.rack.id &&
          location.shelf.id === locationForDelete.shelf.id &&
          location.bin.id === locationForDelete.bin.id &&
          location.time === locationForDelete.time)
      })
      this.showPopupDelete = false
      this.warehouseMapLocationForDelete = null
    },
    addWarehouseLocation() {
      this.item.warehouseLocations.push({
        rack: {
          id: null,
          label: ''
        },
        shelf: {
          id: null,
          label: ''
        },
        bin: {
          id: null,
          label: ''
        },
        value: 0,
        time: Date.now()
      })
    }
  },
  created() {
  }
}
</script>

<style lang="scss">
.locations-list {
  .row:not(:first-child) {
    .label-text {
      display: none !important;
    }
  }
  .row:not(:last-child) {
    .col {
      padding-bottom: 0 !important;
    }
  }
}
</style>
